
<ng-container *ngIf="isLoaded">
  <div class="modal-close-btn" (click)="closeModal()">X</div>
  <div class="card mb-3">
    <div class="card-body">
      <div class="pt-4 pb-2">
        <h5 class="card-title text-center pb-0 fs-4">Редакция на Потребител</h5>
        <p class="text-center small">Моля, направете нужните промени</p>
      </div>

      <form [formGroup]="userForm" class="row g-3 needs-validation" (ngSubmit)="onSubmit()">
        <ul ngbNav #nav1="ngbNav" [activeId]="1" class="nav-tabs border-tab">
          <li [ngbNavItem]="1">
            <a ngbNavLink><i class="icofont icofont-ui-home"></i>Основни</a>
            <ng-template ngbNavContent>
              <div class="col-12 mb-3">
                <label for="yourName" class="form-label">Име</label>
                <input type="text" formControlName="name" class="form-control" id="yourName" value="{{editUser.firstName}}">
              </div>
              <div class="col-12 mb-3">
                <label for="yourSurname" class="form-label">Фамилия</label>
                <input type="text" formControlName="surname" class="form-control" id="yourSurname" value="{{editUser.lastName}}">
              </div>
              <div class="col-12 mb-3">
                <label for="egn" class="form-label">ЕГН</label>
                <input type="text" formControlName="egn" class="form-control" id="egn">
              </div>
              <div class="form-group mt-4">
                <label for="responseType">Вид Обратна Връзка</label>
                <div class="payment-wrapper">
                  <select class="form-control" id="responseType" formControlName="responseType">
                    <option *ngFor="let method of responseTypes" [value]="method.value">
                      {{GetCyrilicRequestType(method.value)}}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-12 mb-3">
                <label for="yourUsername" class="form-label">Потребителско име</label>
                <div class="input-group has-validation">
                  <span class="input-group-text">&#64;</span>
                  <input type="text" formControlName="username" class="form-control" id="yourUsername" readonly value="{{editUser.email}}">
                </div>
              </div>
              <div class="col-12 mb-3">
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" formControlName="isService" id="isService">
                  <label class="form-check-label" for="isService">Системен Акаунт</label>
                </div>
              </div>
              <div class="col-12 mb-3">
                <label for="organization" class="form-label">Организация</label>
                <select formControlName="organization" class="form-select">
                  <option value="" disabled selected>Изберете една от съществуващите Организации</option>
                  <option *ngFor="let org of organizations" [value]="org.id" [selected]="+org.id === +editUser.organization">{{org.title}}</option>
                </select>
              </div>
              <div class="col-12 mb-3">
                <label for="role" class="form-label">Роля</label>
                <select formControlName="role" class="form-select">
                  <option value="" disabled>Изберете Роля</option>
                  <option *ngFor="let role of roleTypes" [value]="UserRoleTypes[role]" [selected]="+role === +editUser.role">{{ role.replace('_',' ') }}</option>
                </select>
              </div>
              <div class="col-12 mb-3">
                <label for="userProfession" class="form-label">Професия</label>
                <select formControlName="userProfession" class="form-select">
                  <option value="" disabled selected>Изберете една от съществуващите Професии</option>
                  <option *ngFor="let wg of userProfessions" [value]="wg.idUserProfession" [selected]="+wg.idUserProfession === +editUser.userProfessionIdUserProfession">{{wg.title}}</option>
                </select>
              </div>
            </ng-template>
          </li>
          <li [ngbNavItem]="2">
            <a ngbNavLink><i class="icofont icofont-man-in-glasses"></i>Модул Сигнали</a>
            <ng-template ngbNavContent>
              <div class="col-12 mb-3">
                <label for="workingGroup" class="form-label">ВИК:Ремонта Група</label>
                <select formControlName="workingGroup" class="form-select">
                  <option value="" disabled selected>Изберете една от съществуващите Ремонта Група</option>
                  <option *ngFor="let wg of workingGroups" [value]="wg.id" [selected]="+wg.id === +editUser.idWorkingGroup">{{wg.title}}</option>
                </select>
              </div>
            </ng-template>
          </li>
        </ul>
        <div [ngbNavOutlet]="nav1" class="mt-4"></div>

        <div class="col-12">
          <button class="btn btn-primary w-100" type="submit" [disabled]="!userForm.valid">Промени</button>
        </div>
      </form>

      <!-- Password Reset Section - Separate Form (Admin resets user password) -->
      <div class="mt-4 pt-4 border-top">
        <h6 class="mb-3"><i class="icofont icofont-key"></i> Задаване на Нова Парола</h6>
        <form [formGroup]="passwordForm" (ngSubmit)="onResetPassword()">
          <!-- New Password -->
          <div class="col-12 mb-3">
            <label for="newPassword" class="form-label">Нова Парола <span class="text-danger">*</span></label>
            <div class="input-group">
              <input [type]="showNewPassword ? 'text' : 'password'"
                     formControlName="newPassword"
                     class="form-control"
                     id="newPassword"
                     [class.is-invalid]="pf['newPassword'].invalid && pf['newPassword'].touched"
                     placeholder="Въведете нова парола">
              <button type="button" class="btn btn-outline-secondary" (click)="toggleNewPasswordVisibility()">
                <i [class]="showNewPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
              </button>
            </div>
            <div *ngIf="pf['newPassword'].invalid && pf['newPassword'].touched" class="invalid-feedback d-block">
              <div *ngIf="pf['newPassword'].errors?.['required']">Новата парола е задължителна</div>
              <div *ngIf="pf['newPassword'].errors?.['minlength']">Паролата трябва да е поне 6 символа</div>
            </div>
          </div>

          <!-- Confirm Password -->
          <div class="col-12 mb-3">
            <label for="confirmPassword" class="form-label">Потвърди Парола <span class="text-danger">*</span></label>
            <div class="input-group">
              <input [type]="showConfirmPassword ? 'text' : 'password'"
                     formControlName="confirmPassword"
                     class="form-control"
                     id="confirmPassword"
                     [class.is-invalid]="pf['confirmPassword'].invalid && pf['confirmPassword'].touched"
                     placeholder="Потвърдете новата парола">
              <button type="button" class="btn btn-outline-secondary" (click)="toggleConfirmPasswordVisibility()">
                <i [class]="showConfirmPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
              </button>
            </div>
            <div *ngIf="pf['confirmPassword'].invalid && pf['confirmPassword'].touched" class="invalid-feedback d-block">
              <div *ngIf="pf['confirmPassword'].errors?.['required']">Потвърждението на паролата е задължително</div>
              <div *ngIf="pf['confirmPassword'].errors?.['passwordMismatch']">Паролите не съвпадат</div>
            </div>
          </div>

          <!-- Reset Password Button -->
          <div class="col-12">
            <button class="btn btn-warning w-100" type="submit" [disabled]="passwordForm.invalid || isChangingPassword">
              <span *ngIf="isChangingPassword" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
              {{ isChangingPassword ? 'Задаване...' : 'Задай Нова Парола' }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>

</ng-container>
